module.exports = __webpack_public_path__ + "static/media/Logo.383f0efe.png";